<template>
      <Bubble>
        <!-- <vue-headful title="Kontakt - Dachaudenktweiter"/> -->
        <div class="row">
          <div class="col">
            <img src="../assets/grafiken/bild_kontakt.gif">
          </div>
          <div class="col">
            <h1 class="mb-3">Kontakt</h1>
            <p>Ihre Mitwirkung ist uns wichtig! Daher können Sie uns auch gerne telefonisch oder per Email kontaktieren. Wir freuen uns auf Ihre Nachricht!</p>
            <ul>
              <li>GROSSE KREISSTADT DACHAU</li>
              <li>Stadtbauamt/Stadtplanung</li>
              <li>Konrad-Adenauer-Straße 2-6</li>
              <li>85221 Dachau</li>
              <li>Telefon 0049 (0)8131 75-110</li>
              <li>Fax 0049 (0)8131 75-160</li>
              <li><a href="mailto:stadtplanung@dachau.de">stadtplanung@dachau.de</a></li>
              <li><a href="https://www.dachau.de" target="blank">www.dachau.de</a></li>
            </ul>
            <hr>
            <h1 class="mt-5 mb-3">Aktuelle Termine</h1>
            <p>Wenn Sie uns bei einer Veranstaltung besuchen möchten, um uns Ihre Ideen persönlich mitzuteilen, besuchen Sie eine unserer Veranstaltungen, hier sind alle vergangenen und aktuellen <router-link to="/termine">Termine</router-link>.</p>
          </div>
        </div>
      </Bubble>
</template>

<script>
export default {
  metaInfo: {
    title: "Kontakt"
  }
};
</script>


<style scoped lang="scss">
ul {
  padding: 0;
  li {
    list-style: none;
    padding: 3px;
    a {
      text-transform: lowercase;
    }
  }
}
img {
  width: 100%;
}
</style>